import { render, staticRenderFns } from "./ChangePermiss.vue?vue&type=template&id=22eb3844&scoped=true&"
import script from "./ChangePermiss.vue?vue&type=script&lang=js&"
export * from "./ChangePermiss.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22eb3844",
  null
  
)

export default component.exports